import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    pesqNota: ["payload"],
    removerNotaTabela: ["payload"],
    removerNotasTabela: ["payload"],
    onEditarTable: ["payload"],
    onEditarTableNovo: ["payload"],
    onDesmarcarTableNovo: ["payload"],
    onAdicionarNotaTableNovo: ["payload"],
    onExcluirTable: ["payload"],
    onEditarUsers: ["payload"],
    setSkip: ["payload"],
    setLoadSkipPesq: ["payload"],
    setLoadPesq: ["payload"],
    setFiltrosPesq: ["payload"],
    setMotoClientePesq: ["payload"],
    enviarEmail: ["payload"],
    buscarDest: ["payload"],
    buscarDestSucess: ["payload"],
    buscarTransp: ["payload"],
    buscarTranspSucess: ["payload"],
    listarUsuariosSucesso: ["payload"],
});

const INITIAL_STATE = {
    filtros: {},
    usuariosLista: [],
    loadPesq: false,
    loadSkipPesq: false,
    buttonDisabled: false,
    tabelaNotas: {
        dados: [],
    },
    valoresIniciais: {
        nome: "",
        numero: "",
        situacao: "",
        dt_foto: "",
        base: { label: "", value: "" },
        dt_entrega: "",
    },
    usuariosLista: [],
    basesLista: [],
    usuarioEditar: {},
    notaSele: {},
    motoClientesVerificadas: [],
    listaNotasEmail: [],
    listaNotasExcel: [],
    transp: [],
    dest: [],
};

const pesqNota = (state = INITIAL_STATE, action) => {
    const pesqDados = action.payload;

    let lista = Array.isArray(pesqDados.dados) ? pesqDados.dados : [];
    const dados = Array.isArray(pesqDados.dados) ? pesqDados.dados : [];
    let listaNotasEmail = [];
    let listaNotasExcel = [];

    for (let i in lista) {
        listaNotasExcel.push({
            numero: lista[i].numero,
            serie: lista[i].serie,
            cnpj: lista[i].cnpj_embarca,
            nome: lista[i].nome_embarca,
            situacao: lista[i].sit_atual,
            dataSituacao: lista[i].dy_sit_atual,
            status: lista[i].status,
            protocolo: lista[i].protocolo,
            cpfScanner: lista[i].cpf_scanner,
            cpfEditor: lista[i].cpf_editor,
            dataEntrega: lista[i].data_entrega,
            dtaFoto: lista[i].data_foto,
            envolvidos: lista[i].envolvidos,
            createAt: lista[i].created_at,
        });
    }

    return {
        ...state,
        tabelaNotas: {
            total: pesqDados.total,
            pesquisado: state.loadSkipPesq
                ? state.tabelaNotas.pesquisado + pesqDados.pesquisados
                : pesqDados.pesquisados,
            dados,
        },
        listaNotasEmail,
        listaNotasExcel,
    };
};

const removerNotaTabela = (state = INITIAL_STATE, action) => {
    const payloadData = action.payload;

    return {
        ...state,
        tabelaNotas: {
            total: --state.tabelaNotas.total,
            pesquisado: --state.tabelaNotas.pesquisado,
            dados: state.tabelaNotas.dados.filter(
                (el, index) => el.ar !== payloadData
            ),
        },
    };
};

const removerNotasTabela = (state = INITIAL_STATE, action) => {
    const { lista } = action.payload;
    return {
        ...state,
        tabelaNotas: {
            total: state.tabelaNotas.total - lista.length,
            pesquisado: state.tabelaNotas.pesquisado - lista.length,
            dados: state.tabelaNotas.dados.filter(
                (item) => !lista.some((element) => element === item.ar)
            ),
        },
    };
};

const onEditarTable = (state = INITIAL_STATE, action) => {
    let payload = action.payload;

    let nota = {
        ...payload.nota,
        historico: payload.novaNota.historico_nota,
        status: payload.novaNota.status_nota,
        situacaoNota: payload.novaNota.situacao_atual,
    };

    let novasNotas = state.tabelaNotas.dados.map((item) =>
        item.ar_nota === payload.novaNota.ar_nota ? nota : item
    );

    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados: novasNotas,
        },
        notaSele: nota,
    };
};
const onEditarTableNovo = (state = INITIAL_STATE, action) => {
    const { notas } = action.payload;

    let dados = [];

    dados = state.tabelaNotas.dados.map((element) =>
        notas.hasOwnProperty(element.ar)
            ? {
                  ...element,
                  ...notas[element.ar],
                  tableData: { ...element.tableData, checked: false },
              }
            : {
                  ...element,
                  tableData: { ...element.tableData, checked: false },
              }
    );
    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados,
        },
    };
};

const onDesmarcarTableNovo = (state = INITIAL_STATE, action) => {
    const { notas } = action.payload;

    let dados = [];

    dados = state.tabelaNotas.dados.map((element) =>
        notas.hasOwnProperty(element.ar)
            ? {
                  ...element,
                  tableData: { ...element.tableData, checked: false },
              }
            : {
                  ...element,
                  tableData: { ...element.tableData, checked: false },
              }
    );
    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados,
        },
    };
};

const onAdicionarNotaTableNovo = (state = INITIAL_STATE, action) => {
    const { notas } = action.payload;

    let dados = [];

    dados = state.tabelaNotas.dados.map((element) =>
        notas.hasOwnProperty(element.ar)
            ? {
                  ...element,
                  ...notas[element.ar],
                  tableData: { ...element.tableData, checked: false },
              }
            : {
                  ...element,
                  tableData: { ...element.tableData, checked: false },
              }
    );
    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados,
        },
    };
};

const onExcluirTable = (state = INITIAL_STATE, action) => {
    let payload = action.payload;

    let nota = {
        ...payload.nota,
        historico: payload.novaNota.historico_nota,
        status: payload.novaNota.status_nota,
        situacaoNota: payload.novaNota.situacao_atual,
    };

    let novasNotas = state.tabelaNotas.dados.map((item) =>
        item.ar_nota === payload.novaNota.ar_nota ? nota : item
    );

    return {
        ...state,
        tabelaNotas: {
            dados: novasNotas,
        },
        notaSele: nota,
    };
};

const setSkip = (state = INITIAL_STATE, action) => {
    const pesqDados = action.payload;

    const newDados = Array.isArray(action.payload.dados)
        ? action.payload.dados
        : [];
    const oldDados = state.tabelaNotas.dados;

    return {
        ...state,
        tabelaNotas: {
            pesquisado: state.loadSkipPesq
                ? state.tabelaNotas.pesquisado + pesqDados.pesquisados
                : pesqDados.pesquisados,
            total: pesqDados.total,
            dados: [...oldDados, ...newDados],
        },
    };
};

const onEditarUsers = (state = INITIAL_STATE, action) => {
    const payload = action.payload;
    let response = {};

    response = {
        nome: payload.nome_base,
        numero: payload.numero,
        grupo_emp: payload.grupo_emp,
        empresas: payload.empresas,
        dt_foto: payload.dt_foto_base,
        situacao: payload.situacao_base,
        tableData: {
            id: payload.tableId,
        },
        grupo_usuario: "dng",
    };

    let novaLista = state.usuariosLista.map((item) =>
        item.tableData.id === payload.tableId ? response : item
    );

    return {
        ...state,
        usuariosLista: novaLista,
    };
};

const setLoadSkipPesq = (state = INITIAL_STATE, action) => ({
    ...state,
    loadSkipPesq: action.payload,
});

const setLoadPesq = (state = INITIAL_STATE, action) => ({
    ...state,
    loadPesq: action.payload,
});

const setFiltrosPesq = (state = INITIAL_STATE, action) => ({
    ...state,
    filtros: action.payload,
});

const buscarDest = (state = INITIAL_STATE, action) => ({
    ...state,
    dest: action.payload,
});

const buscarTransp = (state = INITIAL_STATE, action) => ({
    ...state,
    transp: action.payload,
});

const setMotoClientePesq = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        motoClientesVerificadas: action.payload,
    };
};

const listarUsuariosSucesso = (state = INITIAL_STATE, action) => ({
    ...state,
    usuariosLista: action.payload,
});

export default createReducer(INITIAL_STATE, {
    [Types.PESQ_NOTA]: pesqNota,
    [Types.REMOVER_NOTA_TABELA]: removerNotaTabela,
    [Types.REMOVER_NOTAS_TABELA]: removerNotasTabela,
    [Types.ON_EXCLUIR_TABLE]: onExcluirTable,
    [Types.ON_EDITAR_TABLE]: onEditarTable,
    [Types.ON_EDITAR_TABLE_NOVO]: onEditarTableNovo,
    [Types.ON_DESMARCAR_TABLE_NOVO]: onDesmarcarTableNovo,
    [Types.ON_ADICIONAR_NOTA_TABLE_NOVO]: onAdicionarNotaTableNovo,
    [Types.SET_SKIP]: setSkip,
    [Types.SET_LOAD_SKIP_PESQ]: setLoadSkipPesq,
    [Types.SET_LOAD_PESQ]: setLoadPesq,
    [Types.SET_FILTROS_PESQ]: setFiltrosPesq,
    [Types.SET_MOTO_CLIENTE_PESQ]: setMotoClientePesq,
    [Types.BUSCAR_DEST_SUCESS]: buscarDest,
    [Types.BUSCAR_TRANSP_SUCESS]: buscarTransp,
    [Types.LISTAR_USUARIOS_SUCESSO]: listarUsuariosSucesso,
    [Types.ON_EDITAR_USERS]: onEditarUsers,
});
